import React, { useState } from 'react';
import { Grid, TextField, Button, Typography } from '@mui/material';
import { Alert } from '@mui/material';
import { Navigate } from 'react-router-dom';

import { isAuthenticated } from '../utils/auth';
import { ROOTINE_APP_URL } from '../config';
import useAPI from '../utils/useApi';
import { APIRequests } from '../config/api';
import { LoginRequest } from '../types';
import { colors } from '../utils/theme';

export const Login = (): JSX.Element => {
  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [submitted, setSubmitted] = useState<boolean>(false);
  let loginApi = useAPI(APIRequests.Login);

  const handleSubmit = async (_: React.MouseEvent) => {
    setError('');
    const loginReq: LoginRequest = {
      username: email,
    };
    try {
      await loginApi.execute({ body: loginReq });
      setSubmitted(true);
    } catch (err) {
      if (err instanceof Error) {
        // handle errors thrown from frontend
        console.error('error from api');
        setError(err.message);
      } else {
        // handle errors thrown from backend
        setError('Something went wrong! Please contact support for assistance');
        console.error(err);
      }
    }
  };

  return isAuthenticated() ? (
    <Navigate to="/dashboard" />
  ) : (
    <>
      <Grid
        container
        spacing={2}
        alignItems="flex-end"
        sx={{
          px: { xs: 2, sm: 10, md: 20, lg: 40, xl: 60 },
          paddingTop: { sm: 20 },
        }}
      >
        <Grid item xs={12} container justifyContent="center">
          <img
            src="/images/logo_black.svg"
            alt="logo"
            style={{ margin: 25 }}
          />
        </Grid>
        {!submitted && (
          <>
            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              textAlign="center"
            >
              <Typography variant="h4" color="primary">
                Log in to your dashboard
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="email"
                label="Email"
                type="email"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.currentTarget.value)
                }
                autoFocus
                required
                fullWidth
              />
            </Grid>
            <Grid container alignItems="center">
              {error && (
                <Grid item>
                  <Alert severity="error">{error}</Alert>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  width: '100%',
                  backgroundColor: colors.brand.PRIMARY_RED,
                  color: colors.greys.BASE_WHITE,
                  '&:hover': {
                    backgroundColor: colors.brand.DARK_RED,
                  },
                }}
              >
                Login
              </Button>
            </Grid>
          </>
        )}
        {submitted && (
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            textAlign="center"
          >
            <Typography color="primary">
              If you have an account, you will receive an email with a link to
              access your account
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Button
            disableFocusRipple
            disableRipple
            variant="text"
            onClick={() => (window.location.href = `${ROOTINE_APP_URL}/quiz`)}
          >
            No Account? Create a profile now
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
